import Request from './baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}


const _getTotalItemsCount = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/items-count?${params}`,
    config
  )
}

const _getTotalInteractionsCount = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/interactions-count?${params}`,
    config
  )
}

const _getTotalInteractionsByTypesCount = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/interactions-types-count?${params}`,
    config
  )
}

const _getTotalCustomersCount = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/customers-count?${params}`,
    config
  )
}

const _getTotalInteractionsByDay = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/interactions-by-day?${params}`,
    config
  )
}

const _getRFMReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/rfm?${params}`,
    config
  )
}

const _getRFMReportText = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/rfm-text?${params}`,
    config
  )
}

const _getTotalSessionsCount = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/session-count?${params}`,
    config
  )
}

const _getRevenue = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/revenue?${params}`,
    config
  )
}

const _getRevenueRate = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/revenue-rate?${params}`,
    config
  )
}

const _getRevenueAvg = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/revenue-avg?${params}`,
    config
  )
}

const _getRecoDashboard = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/reco-dashboard?${params}`,
    config
  )
}

const _getRecoPageDashboard = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/reco?${params}`,
    config
  )
}

const _getActiveExperiences = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/active-experiences?${params}`,
    config
  )
}

const _getActiveABTests = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/active-abtests?${params}`,
    config
  )
}

const _getExecutingJourneys = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/executing-journeys?${params}`,
    config
  )
}

const _getPersonalizationDashboard = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-indicators?${params}`,
    config
  )
}

const _getSessionsTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-details/sessions?${params}`,
    config
  )
}

const _getImpressionsTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-details/impressions?${params}`,
    config
  )
}

const _getConversionsTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-details/convertions?${params}`,
    config
  )
}

const _getRevenueTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-details/revenue?${params}`,
    config
  )
}

const _getRevenueTotalTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-details/total-revenue-personalized?${params}`,
    config
  )
}

const _getRevenueRateTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-details/session-purchase-rate?${params}`,
    config
  )
}

const _getAOVTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-details/purchase-aov-personalized?${params}`,
    config
  )
}

const _getTotalSessionsTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/billing/month-sessions?${params}`,
    config
  )
}

const _getRecoImpressionsTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-details/reco-impressions?${params}`,
    config
  )
}

const _getRecoSessionsTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-details/reco-sessions?${params}`,
    config
  )
}

const _getRecoCRTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-details/reco-cr?${params}`,
    config
  )
}

const _getRecoCTRTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-details/reco-ctr?${params}`,
    config
  )
}

const _getRecoDirectRevenueTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-details/reco-direct-revenue?${params}`,
    config
  )
}

const _getRecoAssistedRevenueTimeline= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/goals-details/reco-indirect-revenue?${params}`,
    config
  )
}

const _getDownloadRecoCRReport= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/reco-cr-download?${params}`,
    config
  )
}

const _getNPSFeedbackReport= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/feedback/nps-report?${params}`,
    config
  )
}

const _geFeedbackTypeReport= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/feedback/icons-report?${params}`,
    config
  )
}

const _getNPSCommentsFeedbackReport= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/feedback/nps-comments?${params}`,
    config
  )
}

// --- Surveys por email (bloque survey de Mailcraft en broadcasts/journeys) ---

const _getEmailSurveyList = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/surveys/list?${params}`,
    config
  )
}

const _getEmailSurveySummary = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/surveys/summary?${params}`,
    config
  )
}

const _getEmailSurveyComments = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/surveys/comments?${params}`,
    config
  )
}

const _getPersonalizationIndicators = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/personalization/indicators?${params}`,
    config
  )
}

const _getRecommendationsIndicators = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/indicators?${params}`,
    config
  )
}

const _getRecommendationsCustomers = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/customer-count?${params}`,
    config
  )
}

const _getPersonalizationsCustomers = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/personalization/customer-count?${params}`,
    config
  )
}


const _getJourneysIndicators = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/journeys/indicators?${params}`,
    config
  )
}

const _getJourneysReports = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/journeys/reports?${params}`,
    config
  )
}

// Journey v2 metrics, served from ClickHouse
// (admin-apis: /api/analytics/journeys/metrics and .../metrics/timeline)
const _getJourneyMetrics = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/journeys/metrics?${params}`,
    config
  )
}

const _getJourneyMetricsTimeline = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/journeys/metrics/timeline?${params}`,
    config
  )
}

const _getJourneysInPeriod = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/journeys/in-period?${params}`,
    config
  )
}

const _getJourneyNotificationMetrics = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/journeys/notifications?${params}`,
    config
  )
}

const _getJourneyNotificationsTimeline = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/journeys/notifications/timeline?${params}`,
    config
  )
}

const _getJourneyAttribution = params => {
  const token = getUserToken()
  const config = { headers: { authorization: `Bearer ${token}` } }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/journeys/attribution?${params}`,
    config
  )
}

const _getJourneyAttributionTimeline = params => {
  const token = getUserToken()
  const config = { headers: { authorization: `Bearer ${token}` } }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/journeys/attribution/timeline?${params}`,
    config
  )
}

const _getJourneyStepCounts = params => {
  const token = getUserToken()
  const config = { headers: { authorization: `Bearer ${token}` } }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/journeys/steps?${params}`,
    config
  )
}

// Pagina de destinatarios de un paso de mensaje del embudo (modal).
const _getJourneyStepRecipients = params => {
  const token = getUserToken()
  const config = { headers: { authorization: `Bearer ${token}` } }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/journeys/steps/recipients?${params}`,
    config
  )
}

// Destinatarios de un paso de mensaje del embudo (CSV o Excel). Blob por lo
// mismo que el export de insights: como texto se pierde el BOM.
const _getJourneyStepRecipientsExport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    },
    responseType: 'blob'
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/journeys/steps/recipients/export?${params}`,
    config
  )
}

const _getBroadcastsReports = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/indicators?${params}`,
    config
  )
}

const _getTotalEmails= params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/billing/emails?${params}`,
    config
  )
}

const _getRecoTransactionsReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/transactions-metrics?${params}`,
    config
  )
}

const _getRecoItemsPurchasesReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/items-purchases-metrics?${params}`,
    config
  )
}

const _getRecoItemsPurchasesReportByDay = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/items-purchases-metrics-by-day?${params}`,
    config
  )
}

const _getRecoItemsPurchasesReportByDayCsv = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/items-purchases-metrics-by-day-csv?${params}`,
    config
  )
}

const _getRecoPersonalizationsInPerdiod = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/personalizations-in-period?${params}`,
    config
  )
}

const _getPersonalizationsInPeriod = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/personalization/personalizations-in-period?${params}`,
    config
  )
}

// Eventos genéricos de los contents (gsSDK.track) vía admin-apis → events-duck.
// query: daily | breakdown | keys | sample. csv: devuelve el CSV como texto.
const _getEventAnalytics = ({ query, params, csv = false }) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }
  if (csv) config.responseType = 'text'
  return Request.get(`${window.config.VUE_APP_BACKEND}/api/event-analytics/${query}?${params}${csv ? '&format=csv' : ''}`, config)
}

const _getPersonalizationTotalsReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/personalization/totals?${params}`,
    config
  )
}

const _getPersonalizationTotalsByPeriodReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/personalization/totals-by-period?${params}`,
    config
  )
}

const _getPersonalizationsListReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/personalization/personalizations-list?${params}`,
    config
  )
}

const _getPersonalizedSessionsReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/personalization/personalized-sessions?${params}`,
    config
  )
}

const _getPersonalizationTransactionsReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/personalization/transactions-metrics?${params}`,
    config
  )
}

const _getPersonalizationTransactionsByPeriodReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/personalization/transactions-by-period?${params}`,
    config
  )
}

const _getRecommendationsTotalsReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/totals?${params}`,
    config
  )
}

const _getRecommendationsItemsPurchasesRanking = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/items-purchases-ranking?${params}`,
    config
  )
}

const _getRecommendationsTotalsByPeriodReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/totals-by-period?${params}`,
    config
  )
}

const _getRecommendationsSessionsReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/session-metrics?${params}`,
    config
  )
}

const _getRecommendationsFunnelViewAndCart = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/funnel-view-and-cart?${params}`,
    config
  )
}

const _getRecommendationsFunnelPurchase = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/funnel-purchase?${params}`, config) 
}

const _getRecommendationsItemsRanking = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }
  return Request.get(`${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/items-ranking?${params}`, config)
}

const _getRecommendationsItemsPurchasesByPeriod = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/items-revenue-by-period?${params}`, config)
}

const _getRecommendationsTransactionsByPeriod = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/transactions-by-period?${params}`, config)
  } 




const _getItemsPopularityReport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/items/popularity?${params}`,
    config
  )
}

const _getTopPopularItems = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/items/top-popular?${params}`,
    config
  )
}

const _getCatalogInsightsSummary = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/items/insights/summary?${params}`,
    config
  )
}

const _getCatalogInsightsCategories = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/items/insights/categories?${params}`,
    config
  )
}

const _getCatalogInsightsList = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/items/insights/list?${params}`,
    config
  )
}

// CSV con la lista completa de una pestaña (no solo la página cargada). Blob
// y no texto: decodificarlo como texto le saca el BOM y Excel lee mal las tildes.
const _getCatalogInsightsExport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    },
    responseType: 'blob'
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/items/insights/export?${params}`,
    config
  )
}

// Métricas por fila en lote (una fila por id; ver helpers/batch-metrics.js).
const _getRecommendationsTotalsByContent = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/totals-by-content?${params}`,
    config
  )
}

const _getRecoItemsPurchasesReportByContent = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/items-purchases-metrics-by-content?${params}`,
    config
  )
}

// Solo los ids de los contents con impresiones de recomendaciones en el período.
const _getRecoPersonalizationIdsInPeriod = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/recommendations/personalization-ids-in-period?${params}`,
    config
  )
}

const _getBroadcastTotalsByBroadcast = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/analytics/broadcast/totals-by-broadcast?${params}`,
    config
  )
}

export default {
  getTotalItemsCount: _getTotalItemsCount,
  getTotalInteractionsCount: _getTotalInteractionsCount,
  getTotalInteractionsByTypesCount: _getTotalInteractionsByTypesCount,
  getTotalCustomersCount: _getTotalCustomersCount,
  getTotalSessionsCount: _getTotalSessionsCount,
  getTotalInteractionsByDay: _getTotalInteractionsByDay,
  getRFMReport:_getRFMReport,
  getRFMReportText:_getRFMReportText,
  getRevenue : _getRevenue,
  getRevenueRate: _getRevenueRate,
  getRevenueAvg: _getRevenueAvg,
  getRecoDashboard: _getRecoDashboard,
  getRecoPageDashboard:_getRecoPageDashboard,
  getActiveABTests: _getActiveABTests,
  getActiveExperiences: _getActiveExperiences,
  getExecutingJourneys: _getExecutingJourneys,
  getPersonalizationDashboard: _getPersonalizationDashboard,
  getSessionsTimeline: _getSessionsTimeline,
  getImpressionsTimeline: _getImpressionsTimeline,
  getRevenueTimeline : _getRevenueTimeline,
  getConversionsTimeline : _getConversionsTimeline,
  getRevenueTotalTimeline: _getRevenueTotalTimeline,
  getRevenueRateTimeline: _getRevenueRateTimeline,
  getAOVTimeline: _getAOVTimeline,
  getTotalSessionsTimeline: _getTotalSessionsTimeline,
  getRecoImpressionsTimeline: _getRecoImpressionsTimeline,
  getRecoSessionsTimeline: _getRecoSessionsTimeline,
  getRecoCRTimeline: _getRecoCRTimeline,
  getRecoCTRTimeline: _getRecoCTRTimeline,
  getRecoAssistedRevenueTimeline: _getRecoAssistedRevenueTimeline,
  getRecoDirectRevenueTimeline: _getRecoDirectRevenueTimeline,
  getDownloadRecoCRReport: _getDownloadRecoCRReport,
  getNPSFeedbackReport: _getNPSFeedbackReport,
  getFeedbackTypeReport: _geFeedbackTypeReport,
  getNPSCommentsFeedbackReport: _getNPSCommentsFeedbackReport,
  getEmailSurveyList: _getEmailSurveyList,
  getEmailSurveySummary: _getEmailSurveySummary,
  getEmailSurveyComments: _getEmailSurveyComments,
  getPersonalizationIndicators: _getPersonalizationIndicators,
  getRecommendationsIndicators: _getRecommendationsIndicators,
  getRecommendationsCustomers: _getRecommendationsCustomers,
  getPersonalizationsCustomers: _getPersonalizationsCustomers,
  getJourneysIndicators: _getJourneysIndicators,
  getJourneysReports: _getJourneysReports,
  getJourneyMetrics: _getJourneyMetrics,
  getJourneyMetricsTimeline: _getJourneyMetricsTimeline,
  getJourneysInPeriod: _getJourneysInPeriod,
  getJourneyNotificationMetrics: _getJourneyNotificationMetrics,
  getJourneyNotificationsTimeline: _getJourneyNotificationsTimeline,
  getJourneyAttribution: _getJourneyAttribution,
  getJourneyAttributionTimeline: _getJourneyAttributionTimeline,
  getJourneyStepCounts: _getJourneyStepCounts,
  getJourneyStepRecipients: _getJourneyStepRecipients,
  getJourneyStepRecipientsExport: _getJourneyStepRecipientsExport,
  getBroadcastsReports: _getBroadcastsReports,
  getTotalEmails: _getTotalEmails,
  getRecoTransactionsReport: _getRecoTransactionsReport,
  getRecoItemsPurchasesReport: _getRecoItemsPurchasesReport,
  getRecoItemsPurchasesReportByDay: _getRecoItemsPurchasesReportByDay,
  getRecoItemsPurchasesReportByDayCsv: _getRecoItemsPurchasesReportByDayCsv,
  getRecoPersonalizationsInPerdiod: _getRecoPersonalizationsInPerdiod,
  getRecommendationsTotalsReport: _getRecommendationsTotalsReport,
  getRecommendationsItemsPurchasesRanking: _getRecommendationsItemsPurchasesRanking,
  getRecommendationsTotalsByPeriodReport: _getRecommendationsTotalsByPeriodReport,
  getRecommendationsSessionsReport: _getRecommendationsSessionsReport,
  getRecommendationsFunnelViewAndCart: _getRecommendationsFunnelViewAndCart,
  getRecommendationsFunnelPurchase: _getRecommendationsFunnelPurchase,
  getRecommendationsItemsRanking: _getRecommendationsItemsRanking,
  getRecommendationsItemsPurchasesByPeriod: _getRecommendationsItemsPurchasesByPeriod,
  getRecommendationsTransactionsByPeriod: _getRecommendationsTransactionsByPeriod,
  getPersonalizationsInPeriod: _getPersonalizationsInPeriod,
  getPersonalizationTotalsReport: _getPersonalizationTotalsReport,
  getEventAnalytics: _getEventAnalytics,
  getPersonalizationTotalsByPeriodReport: _getPersonalizationTotalsByPeriodReport,
  getPersonalizationTransactionsReport: _getPersonalizationTransactionsReport,
  getPersonalizationTransactionsByPeriodReport: _getPersonalizationTransactionsByPeriodReport,
  getPersonalizedSessionsReport: _getPersonalizedSessionsReport,
  getPersonalizationsListReport: _getPersonalizationsListReport,
  getItemsPopularityReport: _getItemsPopularityReport,
  getTopPopularItems: _getTopPopularItems,
  getCatalogInsightsSummary: _getCatalogInsightsSummary,
  getCatalogInsightsCategories: _getCatalogInsightsCategories,
  getCatalogInsightsList: _getCatalogInsightsList,
  getCatalogInsightsExport: _getCatalogInsightsExport,
  getRecommendationsTotalsByContent: _getRecommendationsTotalsByContent,
  getRecoItemsPurchasesReportByContent: _getRecoItemsPurchasesReportByContent,
  getRecoPersonalizationIdsInPeriod: _getRecoPersonalizationIdsInPeriod,
  getBroadcastTotalsByBroadcast: _getBroadcastTotalsByBroadcast
}
